export default "__VITE_ASSET__Brcb2mLo__"